import { Autocomplete, TextField } from '@mui/material';
import React, { useState } from 'react';
import { SelectableItem } from 'src/shared/models/gui/selectableItem';

type FundraiserAutocompleteProps = {
  options: SelectableItem[];
  label: string;
  callback: (val: SelectableItem) => void;
  id: string;
};

export const FundraiserSettingsAutocomplete = (props: FundraiserAutocompleteProps) => {
  const { options, callback, label, id } = props;

  const [value, setValue] = useState<SelectableItem | null>(options[0]);
  const [inputValue, setInputValue] = useState('');

  return (
    <Autocomplete
      disablePortal
      size='small'
      id={id}
      options={options}
      value={value}
      isOptionEqualToValue={(option, val) => option.value === val.value}
      onChange={(_event: React.SyntheticEvent, newValue: SelectableItem | null) => {
        setValue(newValue);
        if (newValue) callback(newValue);
      }}
      inputValue={inputValue}
      onInputChange={(_event: React.SyntheticEvent, newInputValue) => {
        setInputValue(newInputValue);
      }}
      renderInput={(params) => <TextField {...params} label={label} />}
    />
  );
};
